import { makeApiRequest } from './utils/api';
import { GOHIGHLEVEL_CONFIG } from '../../config/gohighlevel.config';
import { CUSTOM_FIELD_IDS } from '../../config/customFields.config';
import { mapLoanPurpose, mapLoanType, mapUnitType } from './utils/mappers';

/**
 * Crea una nueva oportunidad en GoHighLevel
 * @param {string} contactId - ID del contacto
 * @param {object} data - Datos de la oportunidad
 * @returns {Promise<object>} Oportunidad creada
 */
export const createGoHighLevelOpportunity = async (contactId, data) => {

  try {
    // Mapear valores antes de crear opportunityData
    const mappedLoanPurpose = mapLoanPurpose(data.loanPurpose);
    const mappedLoanType = mapLoanType(data.loanType);
    const mappedUnitType = mapUnitType(data.unitType);


    const opportunityData = {
      name: `${data.borrowerName} - ${data.propertyAddress}`,
      contactId,
      pipelineId: GOHIGHLEVEL_CONFIG.PIPELINE_ID,
      pipelineStageId: GOHIGHLEVEL_CONFIG.STAGE_ID,
      status: "open",
      indexVersion: 1,
      monetaryValue: data.opportunityValue,
      assignedTo: GOHIGHLEVEL_CONFIG.ASSIGNED_TO,
      source: "Pricer",
      isAttribute: false,
      locationId: GOHIGHLEVEL_CONFIG.LOCATION_ID,
      customFields: [
        {
          id: CUSTOM_FIELD_IDS.loanPurpose,
          field_value: mappedLoanPurpose
        },
        {
          id: CUSTOM_FIELD_IDS.loanType,
          field_value: mappedLoanType
        },
        {
          id: CUSTOM_FIELD_IDS.loanAmount,
          field_value: data.selectedOption.totalLoanAmount
        },
        {
          id: CUSTOM_FIELD_IDS.propertyAddress,
          field_value: data.propertyAddress
        },
        {
          id: CUSTOM_FIELD_IDS.unitType,
          field_value: mappedUnitType
        },
        {
          id: CUSTOM_FIELD_IDS.note,
          field_value: data.note // datos del borrower si es broker
        },
        {
          id: CUSTOM_FIELD_IDS.ltc,
          field_value: data.ltc
        },
        {
          id: CUSTOM_FIELD_IDS.ltv,
          field_value: data.ltv
        },
        {
          id: CUSTOM_FIELD_IDS.documents,
          field_value: {
            "40453320-098f-4f5a-83e1-c2c8b14f38e2": data.preApprovalLetterURL,
            "61308819-81d6-410d-936d-050e200dbe05": data.termSheetURL
          }
        },
        {
          id: CUSTOM_FIELD_IDS.creditScore,
          field_value: data.creditScore
        }
      ]
    };

    const response = await makeApiRequest('/opportunities/', 'POST', opportunityData);
    return response;

  } catch (error) {
    console.error('❌ [OPPORTUNITY] Error al crear oportunidad:', error);
    throw error;
  }
}; 